import { render, staticRenderFns } from "./ProductMaintain.vue?vue&type=template&id=3b998422&scoped=true&"
import script from "./ProductMaintain.vue?vue&type=script&lang=js&"
export * from "./ProductMaintain.vue?vue&type=script&lang=js&"
import style0 from "./ProductMaintain.vue?vue&type=style&index=0&id=3b998422&lanb=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b998422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b998422')) {
      api.createRecord('3b998422', component.options)
    } else {
      api.reload('3b998422', component.options)
    }
    module.hot.accept("./ProductMaintain.vue?vue&type=template&id=3b998422&scoped=true&", function () {
      api.rerender('3b998422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/ProductMaintain.vue"
export default component.exports